import { Component } from '@angular/core';

@Component({
  selector: 'app-form-control-demo',
  templateUrl: './form-control-demo.component.html',
  styleUrls: ['./form-control-demo.component.scss'],
})
export class FormControlDemoComponent {}
